var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gx-orb",class:{ 'gx-orb--fixed': _vm.fixed },style:({
    left: _vm.x,
    top: _vm.y,
    width: _vm.size + 'px',
    height: _vm.size + 'px',
    background: `radial-gradient(circle, ${_vm.color} 0%, transparent 68%)`,
    opacity: _vm.op
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }